import Modal from "@mui/material/Modal";

export default function CatalogueItemModal({
  children,
  darkMode,
  isSaving,
  onClose,
  portalDropdowns = false,
}) {
  return (
    <Modal
      open
      hideBackdrop
      disableEscapeKeyDown={isSaving}
      onClose={() => {
        if (!isSaving) onClose();
      }}
      className={`catalogue-item-modal quotation-editor-shell quotation-editor-page${
        darkMode ? " dark" : ""
      }`}
      style={{ zIndex: 10001, background: "transparent", minHeight: 0 }}
    >
      <div
        className="quotation-dialog-scrim"
        data-catalogue-dropdown-portals={portalDropdowns || undefined}
        tabIndex={-1}
        style={{ outline: "none" }}
        data-clickable={!isSaving}
        onClick={(event) => {
          if (event.target === event.currentTarget && !isSaving) onClose();
        }}
      >
        {children}
      </div>
    </Modal>
  );
}
